export default __webpack_public_path__ + "media/pro/cross-2a08b3e6.svg";